import { transformCurrencyAmountDto } from './currency-amount';
export const transformFeaturedCollectionOrder = dto => ({
  id: dto.id,
  effectiveDays: dto.effective_days,
  payableAmount: transformCurrencyAmountDto(dto.payable_amount),
  salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
  isTaxCovered: dto.is_tax_covered,
  isTaxCoverageAvailable: dto.is_tax_coverage_available
});